import { Link } from 'react-router-dom';
import { EMAIL } from '../data/videos';

export const socials = [
    { label: 'Instagram', href: 'https://www.instagram.com/kenayda_/', icon: 'bi-instagram' },
    { label: 'YouTube', href: 'https://www.youtube.com/@OKenayda', icon: 'bi-youtube' },
    { label: 'Bandcamp', href: 'https://kenayda.bandcamp.com/', icon: 'bi-vinyl-fill' },
    { label: 'Email', href: `mailto:${EMAIL}`, icon: 'bi-envelope' },
]

const WORDMARK = 'O, Kenayda'

// Touch screens have no hover, so light up whichever letter a finger is dragged across
const lightLetterUnderTouch = (event: React.TouchEvent) => {
    const touch = event.touches[0]
    const el = document.elementFromPoint(touch.clientX, touch.clientY)
    if (el?.classList.contains('footer__letter')) {
        el.classList.add('is-lit')
        setTimeout(() => el.classList.remove('is-lit'), 500)
    }
}

const Socials = () => {
    return (
        <footer className='footer'>
            <p className='footer__wordmark' aria-label={WORDMARK} onTouchMove={lightLetterUnderTouch}>
                {WORDMARK.split('').map((char, index) => (
                    <span className='footer__letter' aria-hidden='true' key={index}>
                        {char === ' ' ? ' ' : char}
                    </span>
                ))}
            </p>
            <ul className='footer__socials'>
                {socials.map((social) => (
                    <li key={social.label}>
                        <a href={social.href} target='_blank' rel='noreferrer' aria-label={social.label} title={social.label}>
                            <i className={`bi ${social.icon}`}></i>
                        </a>
                    </li>
                ))}
            </ul>
            <ul className='footer__links'>
                <li><Link to='/listen'>Listen</Link></li>
                <li><Link to='/live'>Live</Link></li>
                <li><Link to='/about'>About</Link></li>
                <li><Link to='/press'>Press</Link></li>
                <li><Link to='/collaborators'>Collaborators</Link></li>
            </ul>
            <p className='footer__meta'>
                Belfast, Northern Ireland &nbsp;·&nbsp; <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
                <br />
                © {new Date().getFullYear()} O, Kenayda
            </p>
        </footer>
    )
}

export default Socials
